import axios from "axios"
import accessToken from "./jwt-token-access/auth-token-header"
import { getConfiguration } from './backend_helper'
import { ToastHelper } from './alerts/alertHelper';

export function getStorageUser() {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj && 'user' in obj ? obj.user : {};
}

export function getToken() {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj && 'token' in obj ? obj.token : false;
}

export function getPolicyUser() {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj && 'user' in obj ? obj.user.can : { configurations: false, users: false };
}


const API_URL = process.env.REACT_APP_BACKEND_API_URL
const axiosApi = axios.create({
    baseURL: API_URL
})
function addHeaderAuthorization() {
    const auth = accessToken()
    if ('Authorization' in auth)
        axiosApi.defaults.headers.common["Authorization"] = 'Bearer ' + auth.Authorization
}

export async function get(url, config = {}) {
    addHeaderAuthorization()
    return await axiosApi
        .get(url, { ...config })
        .then(response => {
            if (response.data.message && (!response.data.status || response.data.showMessage)) {
                ToastHelper(response.data.message, response.data.status ? 'success' : 'error')
            }
            return response.data
        }
        )
        .catch(err => {
            return errors(err)
        })
}

export async function post(url, data, config = {}) {
    addHeaderAuthorization()
    return axiosApi
        .post(url, { ...data }, { ...config })
        .then(response => {
            if (response?.data?.message) {
                ToastHelper(response.data.message, response.data.status ? 'success' : 'error')
            }
            if (response?.message) {
                ToastHelper(response.message, response?.status ? 'success' : 'error')
            }
            return response.data
        }
        )
        .catch(err => {
            return errors(err)
        })
}

export async function postData(url, data, config = {}) {
    addHeaderAuthorization()
    return axiosApi
        .post(url, data, { ...config })
        .then(response => response.data)
        .catch(err => {
            //errors(err)
            //return err
        })
}

export async function file(url, config = {}) {
    addHeaderAuthorization()
    return await axiosApi
        .get(url, { ...config })
        .then(response => response.data)
        .catch(err => {
            errors(err)
        })
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, { ...data }, { ...config })
        .then(response => {
            if (response?.data?.message) {
                ToastHelper(response.data.message, response.data.status ? 'success' : 'error')
            }
            if (response?.message) {
                ToastHelper(response.message, response?.status ? 'success' : 'error')
            }
            return response.data
        })
        .catch(err => {
            errors(err)
        })
}

export async function del(url, config = {}) {
    return await axiosApi
        .delete(url, { ...config })
        .then(response => {
            if (response.data.message) {
                ToastHelper(response.data.message, response.data.status ? 'success' : 'error')
            }
            return response.data
        }).catch(err => {
            errors(err)
        })
}

export function postFile(url, data, config = {}) {
    const formData = new FormData();
    formData.append('file', data.file);
    addHeaderAuthorization();
    return axiosApi
        .post(url, { formData, data }, { ...config })
        .then(response => response.data)
        .catch(err => {
            return err
        })
}

export const postFiles = (url,data,config={}) => {
    const formData = new FormData();
    console.log(data)
    data.xmlFiles.forEach(file => {
        formData.append('files[]', file); // importante: [] para recibir array en Laravel
    });

    data.pdfFiles.forEach(file => {
        formData.append('filesPdf[]', file); // importante: [] para recibir array en Laravel
    });

    addHeaderAuthorization();
    return axiosApi
        .post(url, formData , { ...config })
        .then(response => response.data)
        .catch(err => {
            return err
        })
}

const errors = (e) => {
    let returnError = { status: false }
    var message = ''
    if (e.response && e.response.status) {
        switch (e.response.status) {
            case 404:
                message = "No se encuentra la pagina que buscas"
                break
            case 422:
                message = getError(e)
                ToastHelper(message, 'error')

                break
            case 500:
                message = e.response?.data?.message || "Sorry! something went wrong, please contact our support team";
                break
            case 401:
                message = "Invalid credentials"
                localStorage.removeItem("authUser")
                window.location.replace('/login')
                break
            default:
                message = e.response?.data?.message || e.message
                break
        }
    } else {
        message = e.message
    }
    ToastHelper(message, 'error')
    const data = e.response?.data
    returnError = { status: false, setError: false }
    if (data.errors) {
        returnError = { status: false, errors: data.errors, setError: true }
    }
    return returnError
}


const getError = err => {
    const message = 'Invalido';
    const data = err.response?.data
    if (data?.errors) {
        if (typeof data?.errors === 'object')
            return Object.values(data?.errors).join(', ')
        if (typeof data?.errors === 'object')
            return data?.errors.join(', ')
    }
    if (data?.message)
        return data?.message
    if (data?.error)
        return data?.error
    return message;
}

export const typeResource = (route, type, data = {}, id = null) => {
    switch (type) {
        case 'get':
            return get(route, data);
            break
        case 'show':
            return get(`${route}/${id}`, data);
            break
        case 'post':
            return post(`${route}`, data);
            break
        case 'put':
            return put(`${route}/${id}`, data);
            break
        case 'del':
            return del(`${route}/${id}`);
            break
        case 'postFile':
            return postFile(`${route}`, data);
            break
        case 'postFiles':
            return postFiles(`${route}`, data);
            break
    }
}


//export const sucursalesResource = (type,data={},id=null) => typeResource(url.SUCURSALES_RESOURCE,type,data,id)
export const postLoginToken = (data) => {
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    return axios
        .post(process.env.REACT_APP_BACKEND_API_URL + '/login', data, { headers: headers })
        .then(response => {
            if (response.status >= 200 || response.status <= 299) return response.data
            throw response.data
        })
        .catch(err => {
            var message = ''
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        message = "Lo sentimos el recurso solicitado no existe"
                        break
                    case 422:
                        message = err.response.data.message
                        break
                    case 500:
                        message = "Lo sentimos! algo ha salido mal, por favor contacta a nuestro equipo de soporte."
                        break
                    case 401:
                        message = "Credenciales inválidas"
                        break
                    default:
                        message = err.response?.data?.message || err.message
                        break
                }
                ToastHelper(message, 'error')
                return err.response.data
            } else {
                message = err.message
            }
            throw message
        })
}